import {AppPageView} from "App/Components";
import {html} from "Application.js";

export class ProfileView extends AppPageView {

	static properties = {
	};

	constructor() {
		super();
	}

	///static styles = [];

	renderPage() {
		return html`
			${this.renderLegacy()}
		`;
	}

	renderLegacy() {
		return html`
			NEXT-PROFILE
		`;
	}

}

customElements.define("next-profile-view", ProfileView);